import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserAH } from "src/models/Maintenance/UserAH.models";

interface UserAHState {
  userAHs: IUserAH[];
  userAHToEdit: IUserAH | null;
}

const initialState: UserAHState = {
  userAHs: [],
  userAHToEdit: null,
};

const userAHSlice = createSlice({
  name: "UserAH",
  initialState,
  reducers: {
    setUserAHList: (state, action: PayloadAction<IUserAH[]>) => {
      state.userAHs = action.payload;
    },
    concatListUserAH: (state: UserAHState, action: PayloadAction<IUserAH[]>) => {
      state.userAHs = [...state.userAHs.concat(action.payload)];
    },
    setUserAHToEdit: (state, action: PayloadAction<IUserAH | null>) => {
      state.userAHToEdit = action.payload;
    },
    addUserAH: (state, action: PayloadAction<IUserAH>) => {
      state.userAHs.push(action.payload);
    },
    updateUserAH: (state, action: PayloadAction<IUserAH>) => {
      let itemIndex = state.userAHs.findIndex(
        item => item.userAHId === action.payload.userAHId
      );
      if (itemIndex !== -1) state.userAHs[itemIndex] = action.payload;
    },
    deleteUserAH: (state, action: PayloadAction<number>) => {
      const newArray = state.userAHs.filter(
        item => item.userAHId !== action.payload
      );
      state.userAHs = newArray;
    },
  },
});

export const {
  setUserAHList,
  concatListUserAH,
  setUserAHToEdit,
  addUserAH,
  updateUserAH,
  deleteUserAH,
} = userAHSlice.actions;

export default userAHSlice.reducer;
